export default __webpack_public_path__ + "static/data-intelligence-and-ai-21cc2c9081142e70835bbd6a66f1e519.svg";